<div class="d-flex justify-content-center  align-items-center" style="height: 200px;">
<nb-alert *ngIf="showMessages.error && errors?.length " status="danger">
  <div *ngFor="let error of errors">{{ error }}</div>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length " status="success">
  <div *ngFor="let message of messages">{{ message }}</div>
</nb-alert>
</div>
